/**
 * import and init global plugins
 */

import Vue from 'vue'

import './svg-icon'
import './vue-tooltip'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)
